import Vue from 'vue';
export default Vue.extend({
    name: 'paginationModel',
    props: {
        totalItemCount: {
            type: Number,
            default: 0,
        },
        // 暂时没用到，用到再写相关逻辑
        pageSize: {
            type: Number,
            default: 20,
        },
        pageNo: {
            type: Number,
            default: 1,
        },
        layout: {
            type: String,
            default: 'jumper, total, next, pager, prev',
        },
    },
    methods: {
        currentPage: function (pageNo) {
            this.$emit('get-page-msg', {
                pageNo: pageNo,
            });
        },
    },
});
